import React,{useState,useEffect} from 'react'
import FeedbackSat from './FeedbackSat'
import FeedbackUnsat from './FeedbackUnsat'
import clinicService from '../../services/clinic.service'
import PageLoading from '../common/PageLoading'
const Feedback = ({clinic,patientID,patientUUID}) => {

    const [satisfaction,setSatisfaction] = useState(null)
    const [feedbackVisible,setFeedbackVisible] = useState(true)
    const [satVisible,setSatVisible] = useState(false)
    const [unsatVisible,setUnsatVisible] = useState(false)


    const handleSmileyClicks = (type)=>{
        setSatisfaction(type)

    }

    const handleNextClick = ()=>{
        if(satisfaction){
            const data={
                patientID:patientID |0,
                patientUUID:patientUUID|0,
                feedback: satisfaction=='satisfied'?5:0,
            }
            clinicService.addFeedback(clinic.ID,data)
            .then(res=>{
               // console.log(res)
                setFeedbackVisible(false)
                if(satisfaction==='satisfied'){
                    setSatVisible(true)
                   }
                    
                   if(satisfaction=='unsatisfied'){
                    setUnsatVisible(true) 
                   }
            })
            .catch(err=>console.log(err))
        }
        
    }
    
    return ( 
        <>
            {feedbackVisible &&
             <div className="container mt-4">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                           <div className="card border-light text-bg-light text-center">
                                    <div className="card-body">
                                        <blockquote className="blockquote">
                                            <p>Thank you for taking the time to share your feedback about your recent visit with {clinic.name}</p>
                                        </blockquote>
                                        <div className="d-flex flex-row justify-content-center ">
                                              <div className='me-2'>
                                                <h1 className="bi bi-emoji-frown" style={{color:"red"}}/>
                                                <input type="radio" name="satisfaction" onClick={()=>handleSmileyClicks('unsatisfied')} ></input>
                                                <p>Unsatisfied</p>
                                            </div>
                                            <div className='me-2'>
                                                <h1 className="bi bi-emoji-smile" style={{color:"green"}}/>
                                                <input type="radio" name="satisfaction" onClick={()=>handleSmileyClicks('satisfied')}></input>
                                                <p>Satisfied</p>
                                            </div>
                                           

                                        </div>
                                        <button className="btn btn-secondary mt-3" onClick={()=>handleNextClick()}>Next</button>

                                    </div>
                            </div>
                        </div>
                        
                    </div>
                </div> 
                }
            {satVisible && <FeedbackSat clinic={clinic}/>}
            {unsatVisible &&  <FeedbackUnsat clinic={clinic} patientID={patientID} patientUUID={patientUUID}/>}
        </>
     );
}
 
export default Feedback;